<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
      Step 2: Contact Names and Numbers
    </h2>
    <h3>Phone Numbers</h3>
    <form @submit.prevent="passes(goToNextPage)">
      <d-field label="Phone">
        <d-input v-model="contactPhone" aria-label="phone number" required />
      </d-field>
      <d-field label="Fax">
        <d-input v-model="contactFax" aria-label="fax number" />
      </d-field>
      <d-field label="Toll Free">
        <d-input v-model="contactTollFree" aria-label="contact toll free" />
      </d-field>
      <h3>Primary Contact for QCP</h3>
      <div class="flex flex-wrap -mx-5">
        <d-field label="First Name" class="px-5 w-full md:w-1/2">
          <d-input v-model="primaryContactFirstName" aria-label="primary contact first name" required />
        </d-field>
        <d-field label="Last Name" class="px-5 w-full md:w-1/2">
          <d-input v-model="primaryContactLastName" aria-label="primary contact last name" required />
        </d-field>
      </div>
      <d-field label="Title / Position">
        <d-input v-model="primaryContactTitle" aria-label="primary contact title" required />
      </d-field>
      <d-field label="Email Address">
        <d-input v-model="primaryContactEmail" aria-label="primary contact email" type="email" required />
      </d-field>
      <h3>Company Principal #1</h3>
      <div class="flex flex-wrap -mx-5">
        <d-field label="First Name" class="px-5 w-full md:w-1/2">
          <d-input v-model="companyPrincipalFirstName" aria-label="company principal first name" required />
        </d-field>
        <d-field label="Last Name" class="px-5 w-full md:w-1/2">
          <d-input v-model="companyPrincipalLastName" aria-label="company principal last name" required />
        </d-field>
      </div>
      <d-field label="Title / Position">
        <d-input v-model="companyPrincipalTitle" aria-label="company principal title" required />
      </d-field>
      <d-field label="Email Address">
        <d-input v-model="companyPrincipalEmail" aria-label="company principal email address" type="email" required />
      </d-field>
      <h3>Company Principal #2</h3>
      <div class="flex flex-wrap -mx-5">
        <d-field label="First Name" class="px-5 w-full md:w-1/2">
          <d-input v-model="secondCompanyPrincipalFirstName" aria-label="second company principal first name" required />
        </d-field>
        <d-field label="Last Name" class="px-5 w-full md:w-1/2">
          <d-input v-model="secondCompanyPrincipalLastName" aria-label="first name" required />
        </d-field>
      </div>
      <d-field label="Title / Position">
        <d-input v-model="secondCompanyPrincipalTitle" aria-label="second company principal title" required />
      </d-field>
      <d-field label="Email Address">
        <d-input v-model="secondCompanyPrincipalEmail" aria-label="second company principal email" type="email" required />
      </d-field>

      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '../../../../Resources/scripts/utilities/field.utilities';
  import { APPLY_FOR_LICENSING_FORM } from '../../../../Resources/scripts/store/mutation-types';

  const { mapActions } = createNamespacedHelpers('applyForLicensing');

  export default {
    parent: true,

    computed: {
      ...mapFields({
        fields: ['contactPhone', 'contactFax', 'contactTollFree', 'primaryContactFirstName', 'primaryContactLastName', 'primaryContactFullName', 'primaryContactTitle', 'primaryContactEmail', 'companyPrincipalFirstName', 'companyPrincipalLastName', 'companyPrincipalTitle', 'companyPrincipalEmail', 'secondCompanyPrincipalFirstName', 'secondCompanyPrincipalLastName', 'secondCompanyPrincipalTitle', 'secondCompanyPrincipalEmail'],
        module: 'applyForLicensing',
        base: 'formFields',
        mutation: APPLY_FOR_LICENSING_FORM.FORM_FIELDS,
      }),
    },

    methods: {
      ...mapActions([
        'goToPrevPage',
        'goToNextPage',
      ]),
    },
  };
</script>